const CompanyProductSang = [
    {
        CID: 1,
        PID: 60,
    },
    {
        CID: 1,
        PID: 93,
    },
    {
        CID: 1,
        PID: 94,
    },
    {
        CID: 2,
        PID: 67,
    },
    {
        CID: 2,
        PID: 68,
    },
    {
        CID: 3,
        PID: 69,
    },
    {
        CID: 3,
        PID: 78,
    },
    {
        CID: 3,
        PID: 82,
    },
    {
        CID: 4,
        PID: 70,
    },
    {
        CID: 4,
        PID: 71,
    },
    {
        CID: 4,
        PID: 72,
    },
    {
        CID: 4,
        PID: 73,
    },
    {
        CID: 4,
        PID: 74,
    },
    {
        CID: 5,
        PID: 75,
    },
    {
        CID: 5,
        PID: 76,
    },
    {
        CID: 5,
        PID: 77,
    },
    {
        CID: 6,
        PID: 79,
    },
    {
        CID: 6,
        PID: 80,
    },
    {
        CID: 6,
        PID: 98,
    },
    {
        CID: 7,
        PID: 85,
    },
    {
        CID: 7,
        PID: 86,
    },
    {
        CID: 7,
        PID: 87,
    },
    {
        CID: 7,
        PID: 88,
    },
    {
        CID: 7,
        PID: 89,
    },
    {
        CID: 7,
        PID: 90,
    },
    {
        CID: 7,
        PID: 91,
    },
    {
        CID: 8,
        PID: 96,
    },
    {
        CID: 8,
        PID: 84,
    },
    {
        CID: 8,
        PID: 92,
    },
    {
        CID: 9,
        PID: 97,
    },
    {
        CID: 9,
        PID: 108,
    },
    {
        CID: 9,
        PID: 61,
    },
    {
        CID: 10,
        PID: 99,
    },
    {
        CID: 10,
        PID: 115,
    },
    {
        CID: 11,
        PID: 117,
    },
    {
        CID: 11,
        PID: 124,
    },
    {
        CID: 11,
        PID: 132,
    },
    {
        CID: 12,
        PID: 114,
    },
    {
        CID: 12,
        PID: 119,
    },
    {
        CID: 12,
        PID: 128,
    },
    {
        CID: 12,
        PID: 140,
    },
    {
        CID: 13,
        PID: 109,
    },
    {
        CID: 13,
        PID: 113,
    },
    {
        CID: 13,
        PID: 116,
    },
    {
        CID: 13,
        PID: 121,
    },
    {
        CID: 13,
        PID: 123,
    },
    {
        CID: 13,
        PID: 129,
    },
    {
        CID: 13,
        PID: 131,
    },
    {
        CID: 14,
        PID: 122,
    },
]
export default CompanyProductSang;